import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import UserState from '../types/UserState'

export const module: Module<UserState, RootState> = {
  namespaced: true,
  actions,
  getters,
  mutations
}
